import { Theme } from '@mui/material'

const useStyles = {
  inlineBlockTypography: {
    display: 'inline-block',
  },
  chipsRequiredAsterisk: {
    fontSize: '10px',
    verticalAlign: 'top',
  },
  releaseNoteChip: (theme: Theme) => ({
    borderRadius: theme.shape.largeBorderRadius,
    height: '22px',
    marginLeft: theme.spacing(),
  }),
  majorChipNotSelected: (theme: Theme) => ({
    backgroundColor: theme.palette.warning.shades['4p'],
  }),
  minorChipNotSelected: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.shades['4p'],
  }),
  majorChip: (theme: Theme) => ({
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
  }),
  minorChip: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  }),
}
export default useStyles
